import axios from 'axios';

const baseURL = process.env.REACT_APP_QUICK_REPLY_BASE_URL;
export const repository = axios.create({
  baseURL,
});
